import {getData,postData} from "@/utils/http";
import config from "@/config";
export default {
	namespaced:true,
	state: {
		tableLoading:true,
		addLoading:false,
		activeItem:null,
		tableList:[],

		//查询条件
		orgId:"",
		pageIndex:1,
		total:0
	},
	mutations: {
       	CHANGE_TABLE_LOADING(state,tableLoading){
			state.tableLoading=tableLoading;
		},
		CHANGE_ADD_LOADING(state,addLoading){
			state.addLoading=addLoading;
		},
		CHANGE_TABLE_DATA(state,changeData){
			state.tableList=changeData.data.rows;
			state.total=changeData.total;
		},
		CHANGE_ACTIVE_ITEM(state,item){
			state.activeItem=item;
		},
		CHANGE_SEARCH_COLL(state,changeData){
			if(changeData["changeKey"]=="orgId"&&typeof changeData["data"]!="object"){
				state[changeData["changeKey"]] = [changeData["data"]];
			}else{
				state[changeData["changeKey"]] = changeData["data"];
			}
		},
		CHANGE_TABLE_INDEX(state,value){
			state.pageIndex=value;
		}
	},
	actions: {

        //获取列表
        getList({commit,state}){
            return new Promise((resolve)=>{
                getData(`mobile/sys/post/list?page=${state.pageIndex}&size=${config.pageSize}&deptId=${state.orgId?state.orgId[state.orgId.length-1]:state.orgId}`).then((res)=>{
					if(res.state==1){
						commit("CHANGE_TABLE_DATA",res);
                        resolve({
                            state:1,
                            msg:"操作成功"
                        });
                    }else{
						commit("CHANGE_TABLE_DATA",{
							data:{
								rows:[],
							},
							total:0
						});
                        resolve({
                            state:0,
                            msg:res.msg
                        });
                    }
                })
            })
		},

		//获取部门列表
        getOrganizationList({commit,state}){
            return new Promise((resolve)=>{
                getData(`mobile/sys/dept/tree`).then((res)=>{
					if(res.state==1){
                        resolve({
                            state:1,
							data:res.data,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
							data:[],
                            msg:res.msg
                        });
                    }
                })
            })
		},


		//添加
		add({commit},addData){
			return new Promise((resolve)=>{
                postData(`mobile/sys/post/save`,addData).then((res)=>{
					if(res.state==1){
						resolve({
                            state:1,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
                            msg:res.msg
                        });
                    }
                })
            })
		},
		remove({commit},id){
			return new Promise((resolve)=>{
                getData(`mobile/sys/post/delete?id=${id}`,{
					id:id
				}).then((res)=>{
                    console.log("post",res);
					if(res.state==1){
						resolve({
                            state:1,
                            msg:"操作成功"
                        });
                    }else{
                        resolve({
                            state:0,
                            msg:res.msg
                        });
                    }
                })
            })
		},
		//写入当前操作条目
		setActiveItem({commit},item){
			commit("CHANGE_ACTIVE_ITEM",item)
		},

		//写入查询条件
		setSearchData({commit},changeData){
			commit("CHANGE_SEARCH_COLL",changeData)
		},
		//修改分页
		setPageIndex({commit},value){
			commit("CHANGE_TABLE_INDEX",value)
		},
		//修改添加loading
		changeAddLoading({commit},value){
			commit("CHANGE_ADD_LOADING",value)
		},
		//修改添加loading
		changeListLoading({commit},value){
			commit("CHANGE_TABLE_LOADING",value)
		}

	}
}
